import QuestionCollapse from "./QuestionCollapse";

const Questions = ({ questionsData }) => {

  return (
    <div className="pb-[60px]">
      <div className="flex justify-center items-center mb-3 lg:mb-5 sm:px-2">
        <h3 className="flex items-center gap-4 w-full font-semibold text-[#383838]">
          <span className="flex-1 h-[2px] rounded-full bg-gradient-to-r from-purple/10 to-transparent"></span>
          <span className="flex items-center whitespace-nowrap px-2 text-[17px] md:text-[23px]">
            <span className="text-[#383838]">سوالات</span>
            <span className="text-[#383838] mx-1.5">متداول</span>
          </span>
          <span className="flex-1 h-[2px] rounded-full bg-gradient-to-l from-purple/10 to-transparent"></span>
        </h3>
      </div>
      <div className="grid grid-cols-2 gap-2 lg:gap-3">
        {questionsData.map((e) => (
          <QuestionCollapse
            q={e.question}
            a={e.answer}
            className={e.id === 1 ? "col-span-2" : null}
          />
        ))}
      </div>
    </div>
  );
};
export default Questions;
